// import DeviceDetector from '@/plugins/device-detector'

export default {
  data () {
    return {
      attemptsLeft: 200,
      checkerInterval: null
    }
  },
  created () {
    this.checkerInterval = setInterval(() => {
      if ((window.dataLayer && window.dataLayer.push) || process.env.NODE_ENV === 'development') {
        clearInterval(this.checkerInterval)
        this.$bus.$emit('data.layer.ready')
      } else {
        this.attemptsLeft--
      }

      if (this.attemptsLeft === 0) {
        clearInterval(this.checkerInterval)
      }
    }, 100)
  }
}



// WEBPACK FOOTER //
// ./src/mixin/gtm.js